import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { CompetitiveHeaderProps } from "../types/competitive-analysis";

export const CompetitiveHeader = ({ analysis }: CompetitiveHeaderProps) => (
  <div className="flex flex-col items-center gap-2">
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a 
            href={analysis.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 cursor-pointer"
          >
            <img 
              src={`https://www.google.com/s2/favicons?domain=${new URL(analysis.url).hostname}&sz=32`}
              alt={`Favicon de ${new URL(analysis.url).hostname}`}
              className="w-4 h-4"
            />
            <span>{new URL(analysis.url).hostname}</span>
          </a>
        </TooltipTrigger>
        <TooltipContent className="max-w-[320px] break-all">
          {analysis.url}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
);